import React from 'react'
import PropTypes from 'prop-types'
import { Checkbox } from 'components/UIElements'

const ValidationPanel = ({
  disabledRequired,
  hasCharLimit,
  isMultiField,
  keepRequiredOnAppearance,
  onToggleInputValidation,
  onToggleRequiredQuestion,
  required,
}) => {
  return (
    <div className='validation panel flexed'>
      <Checkbox
        toggle
        className={keepRequiredOnAppearance ? 'tmg-required-always-on' : ''}
        disabled={disabledRequired}
        label='Required'
        checked={required}
        onClick={onToggleRequiredQuestion}
      />
      {/* {isMultiField && (
          <Checkbox
            toggle
            label='Participant input field validation'
            checked={hasCharLimit}
            onClick={onToggleInputValidation}
          />
        )} */}
    </div>
  )
}

ValidationPanel.propTypes = {
  disabledRequired: PropTypes.bool,
  keepRequiredOnAppearance: PropTypes.bool,
  hasCharLimit: PropTypes.bool,
  isMultiField: PropTypes.bool,
  onToggleInputValidation: PropTypes.func,
  onToggleRequiredQuestion: PropTypes.func,
  required: PropTypes.bool,
}

export default ValidationPanel
